import {
  CustomFieldAttribute,
  CustomFieldAttributeValue,
} from 'apis/customFields';

import { parseCustomFieldAttributeValue } from '../parseCustomFieldAttributeValue';
import { CustomField } from '../useLazyCustomFields';

/**
 * Combines attributes response with value response and returns normalized
 * CustomField type.
 */
export const getCustomFields = (
  attributes: readonly CustomFieldAttribute[] = [],
  values: Record<string, CustomFieldAttributeValue> = {},
  { includeArchived = false, includeDeactivated = false } = {},
): readonly CustomField[] => {
  return attributes
    .filter(
      (attribute) =>
        (includeArchived || !attribute.is_archived) &&
        (includeDeactivated || !attribute.is_deactivated),
    )
    .map((attribute) => ({
      attribute,
      value: parseCustomFieldAttributeValue(attribute, values[attribute.id]),
    }));
};
